import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  createChannel = new Subject();
  updateChannel = new Subject();
  createDetailChannel = new Subject();
  submitChannel = new Subject();
  downloadTempateChannel = new Subject();
  gradeListChannel = new Subject();
  checkPositionQuotaChannel = new Subject();
  listLegalChannel = new Subject()
  listStatusChannel = new Subject()
  repository = new CreateRepository();


  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.updateChannel.next({ status: apiResponse.INITIAL });
    this.createDetailChannel.next({ status: apiResponse.INITIAL });
    this.submitChannel.next({ status: apiResponse.INITIAL });
    this.downloadTempateChannel.next({ status: apiResponse.INITIAL });
    this.gradeListChannel.next({ status: apiResponse.INITIAL });
    this.checkPositionQuotaChannel.next({ status: apiResponse.INITIAL });
    this.listLegalChannel.next({status: apiResponse.INITIAL})
    this.listStatusChannel.next({status: apiResponse.INITIAL})
  }

  fetchCreate = async (query) => {
    try {
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };
  fetchUpdate = async (query) => {
    try {
      await this.repository
        .fetchUpdate(query)
        .then((result) => {
          this.updateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchCreateDetail = async (query) => {
    try {
      this.createDetailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreateDetail(query)
        .then((result) => {
          this.createDetailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createDetailChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchSubmit = async (query) => {
    try {
      this.submitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchSubmit(query)
        .then((result) => {
          this.submitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.submitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchDownloadTemplate = async (query) => {
    try {
      this.downloadTempateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDownloadTemplate(query)
        .then((result) => {
          this.downloadTempateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.downloadTempateChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchGrade = async (query) => {
    try {
      this.gradeListChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGrade(query)
        .then((result) => {
          this.gradeListChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.gradeListChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  checkPositionQuota = async (query) => {
    try {
      this.checkPositionQuotaChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .checkPositionQuota(query)
        .then((result) => {
          this.checkPositionQuotaChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.checkPositionQuotaChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };


  fetchLegalList = async (query) => {
      try {
          this.listLegalChannel.next({status: apiResponse.LOADING})
          await this.repository.fetchLegalList(query).then((result) => {
              this.listLegalChannel.next({ status: apiResponse.COMPLETED, data: result})
          }).catch((error) => {
              this.listLegalChannel.next({ status: apiResponse.ERROR, data: error})
          })
      } catch (error) {
          console.log('rxjs', 'Channel Unsubscribed') 
      }
  }

  fetchStatusList = async (query) => {
      try {
          this.listStatusChannel.next({status: apiResponse.LOADING})
          await this.repository.fetchStatusList(query).then((result) => {
              this.listStatusChannel.next({ status: apiResponse.COMPLETED, data: result})
          }).catch((error) => {
              this.listStatusChannel.next({ status: apiResponse.ERROR, data: error})
          })
      } catch (error) {
          console.log('rxjs', 'Channel Unsubscribed') 
      }
  }
}

export default CreateBloc;
